import React, { useCallback, useState } from 'react';
import { TBannerProps } from '../../types/productFeatureComponent.types';
import breakpoints from '../../../../../constants/breakpoints.constants';
import { getThumbnailProps } from '../../../../../utils/youtube.utils';
import { TMediaCarouselSlide } from '../../../mediaCarousel/types/mediaCarousel.types';
import MediaCarousel from '../../../mediaCarousel';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import ModalDialog from '../../../modalDialog';
import OverlayCarouselPopup from '../../../overlayCarouselPopup';
import { TGalleryItem } from '../../../overlayCarouselPopup/types/overlayCarouselPopup.types';
import Icon from '../../../icon';
import { iconSize } from '../../../../../constants/icon.constants';

const Banner = (props: TBannerProps): JSX.Element => {
  const { component: model, mediaCarouselClassName, mediaHeightClassName, desktopRenditionKey, mobileRenditionKey } = props;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const [showOverlay, setShowOverlay] = useState(false);
  const openOverlayModal = (): void => setShowOverlay(true);
  const closeOverlayModal = (): void => setShowOverlay(false);

  const getCarouselOverlayProps = useCallback(() => {
    const carouselSlides: TMediaCarouselSlide[] = [];
    const overlayCarouselProps: TGalleryItem[] = [];

    model?.assets?.forEach((asset) => {
      overlayCarouselProps.push({
        isVideo: (asset.role === 'video' || asset.role === 'extvideo') && !!asset.full,
        videoUrl: asset.full,
        productImageProps: {
          mobileRendition: asset?.[mobileRenditionKey || 'rendition_mobile_size500'],
          desktopRendition: asset?.[desktopRenditionKey || 'rendition_desktop_size1200'],
          alt: asset.alt,
          ...(asset.role === 'extvideo' && { desktopRendition: { url: getThumbnailProps(asset.full)?.thumbnailImgSrc || '' } }),
        },
        description: { value: asset?.description },
        title: { value: asset?.title },
      });

      carouselSlides.push({
        isVideo: (asset.role === 'video' || asset.role === 'extvideo') && !!asset.full,
        videoUrl: { value: { href: asset.full } },
        productImageProps: {
          mobileRendition: asset.rendition_mobile_size500,
          desktopRendition: asset.rendition_desktop_size1200,
          alt: asset.alt,
          ...(asset.role === 'extvideo' && { desktopRendition: { url: getThumbnailProps(asset.full)?.thumbnailImgSrc || '' } }),
        },
      });
    });

    return { mediaCarouselSlides: carouselSlides, overlayProps: overlayCarouselProps };
  }, [model?.assets]);

  const { mediaCarouselSlides, overlayProps } = getCarouselOverlayProps();

  return (
    <div className="component-details-banner">
      {!isDesktop && props?.showImageOverlay && mediaCarouselSlides?.length > 0 && (
        <div onClick={openOverlayModal}>
          <button className="component-details__expand">
            <Icon iconName="action-expand" size={iconSize.dsk} extraClassName="component-details__expand-icon" />
          </button>
        </div>
      )}
      <MediaCarousel
        slides={mediaCarouselSlides || []}
        mediaHeightClassName={mediaHeightClassName}
        extraClassName={mediaCarouselClassName}
      />
      {!isDesktop && props?.showImageOverlay && mediaCarouselSlides?.length > 0 && (
        <ModalDialog isOpen={showOverlay} close={closeOverlayModal}>
          <OverlayCarouselPopup slides={overlayProps} showNavDeck={true} showOverlayTitleAndDescription={true} />
        </ModalDialog>
      )}
    </div>
  );
};

export default Banner;
